export enum TrialLogType {
    CancelTrial = 'CancelTrial',
    ReactivateTrial = 'ReactivateTrial',
    UpdateTrial = 'UpdateTrial',
    ExtendTrial = 'ExtendTrial',
    PromoteTrial = 'PromoteTrial',
}
